import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupEventByUTCDatePipe',
})
export class GroupEventByUTCDatePipe implements PipeTransform {

 
  transform(collection: Array<any>, property: string = 'EventStartUTC'): Array<any> {
    if(!collection) {
        return [];
    }

    const mappedCollection = collection.map(event => {
      // Parse UTC datetime and convert to local date
      const utcDate = new Date(event.EventStartUTC+'Z');
      const year = utcDate.getFullYear();
      const month = String(utcDate.getMonth() + 1).padStart(2, '0');
      const day = String(utcDate.getDate()).padStart(2, '0');
      const localDateOnly = `${year}-${month}-${day}`;
      
      return {
        ...event, 
        dateOnly: localDateOnly
      };
    });

    // console.log(mappedCollection);
   
    const gc = mappedCollection.reduce((previous, current)=> {
      if (!previous[current.dateOnly]) {
        previous[current.dateOnly] = [];
        }
      
      previous[current.dateOnly].push(current);
        return previous;
    }, {});
    // console.log(Object.keys(gc).map(date => ({ EventStartUTC: date, Games: gc[date] })));
    return Object.keys(gc).map(date => ({ EventStartUTC: date, Events: gc[date] }));
    }  

}
